export class UTF8{
    static getBytes(stringValue:string):number[] {
        var bytes:number[] = [];

        for (var i = 0; i < stringValue.length; ++i) {
            bytes.push(stringValue.charCodeAt(i));
        }
        return bytes;
    }
    static getString(utftext:number[]) {
        var result = "";

        for (var i = 0; i < utftext.length; i++) {
            result += String.fromCharCode(utftext[i]);
        }

        return result;
    }
}